import { Avatar } from "@mui/material";
import moment from "moment";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";

function MessageList({ messages, sender, receiver }) {
  const scrollRef = useRef();

  useEffect(() => {
    if (scrollRef.current) {
      let el = scrollRef.current;
      if (el.children) {
        el.lastElementChild.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [messages]);

  return (
    <div
      className="w-full h-96 p-2 py-7 overflow-scroll transition-all"
      ref={scrollRef}
    >
      {messages.length != 0 ? (
        messages.map((message, index) => {
          const isLeft = message.position == "left";
          const isPrevMessage = messages[index - 1]
            ? messages[index - 1].position == message.position
              ? true
              : false
            : false;

          const isNewDate = messages[index - 1]
            ? messages[index - 1].date.format("DD/MM/YYYY") ==
              message.date.format("DD/MM/YYYY")
              ? false
              : true
            : true;

          const messageClassRightUp =
            " bg-primary text-white rounded-tr-none p-2";
          const messageClassRightDown = "bg-primary text-white  p-2";

          const messageClassLeftUp = "bg-gray-100 rounded-tl-none p-2";
          const messageClassLeftDown = "bg-gray-100 p-2";

          const containerClassUp =
            "pt-1 px-2 " + (isLeft ? "justify-start" : "justify-end");
          const containerClassDown =
            "pt-1 px-2 " + (isLeft ? "justify-start" : "justify-end");

          const timeChipStyle = "text-xsm text-gray-500 flex items-center";
          return (
            <div className="">
              {isNewDate && (
                <div className="text-xsm text-gray-800 flex items-center justify-center my-5">
                  <span className="bg-secondary px-4 py-1 rounded-full">
                    {message.date.format("dddd, MMMM Do YYYY")}
                  </span>
                </div>
              )}

              <div
                className={
                  "flex " +
                  (isPrevMessage ? containerClassDown : containerClassUp)
                }
              >
                {!isLeft && (
                  <span className={timeChipStyle}>
                    {message.date.format("h:mm a")}
                  </span>
                )}

                {isLeft && (
                  <Avatar
                    src={isLeft ? sender.avatar : undefined}
                    className={`-translate-y-5 ${
                      isPrevMessage ? "invisible" : "visible"
                    }`}
                  />
                )}
                <span
                  className={
                    "mx-2 px-4 rounded-full text-sm " +
                    " " +
                    (isLeft
                      ? isPrevMessage
                        ? messageClassLeftDown
                        : messageClassLeftUp
                      : isPrevMessage
                      ? messageClassRightDown
                      : messageClassRightUp)
                  }
                >
                  {message.text}
                </span>
                {isLeft && (
                  <span className={timeChipStyle}>
                    {message.date.format("h:mm a")}
                  </span>
                )}
              </div>
              {/* {!isNextMessage && (
                <div
                  className={
                    "text-xsm text-gray-500 p-2 px-4 " +
                    (isLeft ? "" : "text-right ")
                  }
                >
                  {message.date}
                </div>
              )} */}
            </div>
          );
        })
      ) : (
        <div className="text-center my-5 text-gray-400">No Chat History</div>
      )}
    </div>
  );
}

export default MessageList;
